import React from 'react';
import { Table } from 'reactstrap';

import './ModalTable.scss';

export default function ModalTable({ data = [], dataConfig, index = false }) {
  const inferredConfig = React.useMemo(() => {
    if (dataConfig && dataConfig.length) return dataConfig;
    if (data.length === 0) return [];

    // Auto-generate config from the first row
    const keys = Object.keys(data[0]);
    return keys.map(key => ({
      key,
      label: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize first letter
    }));
  }, [dataConfig, data]);

  const renderHeaders = () =>
    inferredConfig.map(item => {
      if (item?.renderHeader) {
        return (
          <th key={item.key} style={item?.colStyle ? item.colStyle : {}}>
            <div className="d-flex justify-content-between">
              <div>{item.label}</div>
              {item.renderHeader(item)}
            </div>
          </th>
        );
      }
      return (
        <th key={item.key} style={item?.colStyle ? item.colStyle : {}}>
          {item.label}
        </th>
      );
    });

  const renderBody = () => {
    if (data.length === 0) {
      return (
        <tr
          style={{
            border: 'transparent',
          }}
        >
          <td colSpan={inferredConfig.length} className="text-center">
            No data available
          </td>
        </tr>
      );
    }

    return data.map(item => {
      const row = inferredConfig.map(config => {
        if (config?.render) {
          return (
            <td
              key={config.key}
              title={item[config.key]}
              style={config?.colStyle ? config.colStyle : {}}
            >
              {config.render(item)}
            </td>
          );
        }

        if (String(item[config.key])?.trim()) {
          return (
            <td
              key={config.key}
              title={item[config.key]}
              style={config?.colStyle ? config.colStyle : {}}
            >
              {item[config.key]}
            </td>
          );
        }
        return <td key={config.key}>-</td>;
      });
      return (
        <tr>
          {index && (
            <td className="text-center index-col">{data.indexOf(item) + 1}</td>
          )}
          {row}
        </tr>
      );
    });
  };

  return data.length === 0 ? (
    <div className="text-center py-2">No data available</div>
  ) : (
    <div
      className="table-responsive"
      style={{
        border: '2px solid #D0D5DD',
        borderRadius: '8px',
      }}
    >
      <Table className="custom-table mb-0">
        <thead>
          <tr>
            {index && <th className="text-center index-col">#</th>}
            {renderHeaders()}
          </tr>
        </thead>
        <tbody>{renderBody()}</tbody>
      </Table>
    </div>
  );
}
